// eslint-disable-next-line import/prefer-default-export
export const getFileUrl = (
  companyReference: string | undefined,
  objectDataIdentifier: string | undefined,
  timestamp: string | undefined,
  content: string
) => {
  if (!companyReference || !objectDataIdentifier || !timestamp) return "";
  return encodeURI(
    `${window.contextRoot}/rest/object-dataset/${companyReference}/${objectDataIdentifier}/${timestamp}/${content}`
  );
};
